module.exports = __webpack_public_path__ + "img/3.3c468ef0.png";